<template>
  <Tabs value="0">
    <TabList class="div_title2">
      <Tab value="0">{{ $t('menu.reg') }}</Tab>
      <Tab value="1">{{ $t('menu.search') }}</Tab>
    </TabList>
    <TabPanels>
      <TabPanel value="0">
        <div>
          <input type="hidden" id="IDX" name="IDX" value="">
          <div class="grid-form">
            <div class="form-group">
              <label for="ID">계정*</label>
              <InputText class="width100" v-model="id" placeholder="유튜브계정(이메일)"/>
            </div>
            <div class="form-group">
              <label for="TYPE">영상생성방식*</label>
              <Select class="width100" v-model="content" :options="contentType" optionLabel="type" checkmark :highlightOnSelect="false" @change="click({type:'typeChange'})"/>
            </div>
            <div class="form-group">
              <label for="YOUTUBE_NAME">채널명*</label>
              <InputText type="text" v-model="youtubeName" maxlength="20" placeholder="유튜브채널명" />
            </div>
            <div class="form-group">
              <label for="IMAGE_GENERATE_YN">이미지생성*</label>
              <Select class="width100" v-model="imgGenerateYn" :options="imgGenerateYnType" optionLabel="type" checkmark :highlightOnSelect="false" />
            </div>

            <div class="form-group">
              <label for="REG_DATE">분량*</label>
              <InputNumber class="width100" v-model="quantity" placeholder="단위:분"/>
            </div>

            <div class="form-group">
              <label for="ADD_CONTENT_YN">{{ $t('menu.related') }}*</label>
              <Select class="width100" v-model="addContentYn" :options="addContentYnType" optionLabel="type" checkmark :highlightOnSelect="false" />
            </div>

            <div class="form-group">
              <label for="SRC_YOUTUBE_YN">{{ $t('menu.tag') }}</label>
              <InputText class="width100" v-model="tag" placeholder="태그1,태그2..." />
            </div>

            <div class="form-group">
              <label for="TAG">대본*</label>
              <Select class="width100" v-model="srcYoutubeYn" :options="srcYoutubeYnType" optionLabel="type" checkmark :highlightOnSelect="false" />
            </div>

            <div class="form-group">
              <label for="YOUTUBE_URL">재생목록</label>
              <InputText class="width100" v-model="playList" placeholder="유튜브 채널에 생성 필요"/>
            </div>
            
            <div class="form-group">
              <label for="LANGUAGE">언어*</label>
              <Select class="width100" v-model="language" :options="languageType" optionLabel="type" checkmark :highlightOnSelect="false" />
            </div>

            <div class="form-group">
              <label for="KEYWORD">키워드</label>
              <InputText class="width100" v-model="keyword" />
            </div>

            <div class="form-group">
              <label>배경음악</label>
              <Select class="width100" v-model="backMusic" :options="backMusicType" optionLabel="type" checkmark :highlightOnSelect="false" />
            </div>

            <div class="form-group full-width">
              <label>유튜브URL</label>
              <InputText class="width100" v-model="url" :disabled="!disabledUrl"/>
            </div>
            
            <div class="form-group full-width">
              <label>내용입력</label>
              <Textarea v-model="title" autofocus fluid style="width:100%;" autoResize :disabled="!disabledTitle"/>
            </div>

            <div class="form-group full-width">
              <label>추가설명</label>
              <Textarea v-model="desc" autofocus fluid style="width:100%;" autoResize />
            </div>

            <div class="form-group full-width">
              <label>대본 프롬프트*</label>
              <Textarea v-model="scriptPrmpt" autofocus fluid style="width:100%;" autoResize placeholder="영상 내용/말투에 대해서 기술" />
            </div>

            <div class="form-group full-width">
              <label>사진 프롬프트*</label>
              <Textarea v-model="imgPrmpt" autofocus fluid style="width:100%;" autoResize placeholder="영상에 사용할 사진의 스타일에 대해서 기술" />
            </div>
          </div>

          <Divider/>

          <div style="text-align: right; margin-top: 20px;">
            <Button @click="click({type:'INSERT_AUTO_CONTENT'})" :label="$t('menu.reg')" raised />
          </div>
        </div>
      </TabPanel>  
      <TabPanel value="1">
        AUTO#2
      </TabPanel> 
    </TabPanels>
  </Tabs>
  <Dialog v-model:visible="progressVisible" modal :header="$t('sentence.item3')" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    <ProgressBar :value="progressedRate"> {{ progressedCnt }} / {{ progressTotalCnt }} </ProgressBar>
  </Dialog>  
</template>
<script>
import { ref } from 'vue'


export default {
  components: {
  },  

  mounted() {
  }, 
  unmounted() {
  },
  setup() {
    let imgPrmpt = ref(undefined)
    let scriptPrmpt = ref(undefined)
    let desc = ref(undefined)
    let cType = ref(2)
    let keyword = ref(undefined)
    let youtubeName = ref(undefined)
    let id = ref(undefined)
    let name = ref(undefined)
    let quantity = ref(undefined)
    let playList = ref(undefined)
    let tag = ref(undefined)
    let backMusic = ref({type:'선택안함'})
    let title = ref(undefined)
    let url = ref(undefined)
    
    const contentType = ref([{type:'키워드'}, {type:'내용입력'}, {type:'유튜브URL'}, {type:'유튜브URL + 내용입력'}])
    const languageType = ref([{type:'한국어'}, {type:'영어'}, {type:'일본어'}, {type:'스페인어'} ])
    const backMusicType = ref([{type:'선택안함'}, {type:'꿈속 여행'}, {type:'Among Others'}, {type:'Chill Night'}, {type:'Uh Woo Uh'}, {type:'가볍게 번지는 설렘'}, {type:'My new era'}, {type:'시선이 모이는 순간'} , {type:'모두가 나를 바라보고 있어'}, {type:'대담하게 시작해 봐'}, {type:'소소한 희망'} ])
    const srcYoutubeYnType = ref([{type:'AI가 대본 생성'}, {type:'유튜브 검색해서 대본 생성'}])
    const addContentYnType = ref([{type:'관련영상선택가능'}, {type:'관련영상선택불가'}])
    const imgGenerateYnType = ref([{type:'기본사진사용'}, {type:'제미나이사진사용'}])
 
    return {
      id, name, quantity, playList, tag, keyword, imgPrmpt, scriptPrmpt, desc, title, youtubeName, url,
      backMusicType, languageType, contentType, srcYoutubeYnType, addContentYnType, imgGenerateYnType, cType, backMusic
    }
  },
  data() { 
    return { 
      disabledUrl: false,
      disabledTitle: false,
      orderedMap: new Map(),
      autoMenuType:"0",
      status:{},
      totalCnt:0,
      pickDateFrom:ref(new Date()),
      pickDateTo:ref(new Date()),
      contractType:'done',
      conditionDetail:'',
      adjustmentList: [],
      orderList: [],
      ancestryList: [],
      contentList: [],
      page:1,
      param:{},
      date:this.api.getDateByFormat(new Date(), 'YYYYMMDD'),
      content:{type:'키워드'},
      srcYoutubeYn:{type:'AI가 대본 생성'},
      language:{type:'한국어'},
      addContentYn:{type:'관련영상선택가능'},
      imgGenerateYn:{type:'기본사진사용'},
    }
  },
  methods: {
    // this.progressModal(true)
    async click(param) {
      const type = param.type
      if(type === 'INSERT_AUTO_CONTENT') {
        if(!this.id) alert('유튜브계정(이메일) 누락')
        else if(!this.youtubeName) alert('유튜브채널명 누락')
        else if(!this.quantity) alert('분량 누락')
        else if(!this.playList) alert('재생목록 누락')
        else if(!this.imgPrmpt) alert('사진프롬프트 누락')
        else if(!this.scriptPrmpt) alert('대본프롬프트 누락')
        else {
          
          const formData = new FormData()
          formData.append("type", type)
          formData.append("id", this.id)
          formData.append("youtubeName", this.youtubeName)
          formData.append("srcYoutubeYn", this.srcYoutubeYn.type === this.srcYoutubeYnType[0].type ? false : true)
          formData.append("tag", this.tag)
          formData.append("keyword", this.keyword)
          formData.append("desc", this.desc)
          formData.append("title", this.title)
          formData.append("youtubeUrl", this.url) 
          formData.append("playList", this.playList)
          formData.append("quantity", this.quantity)
          formData.append("cType", this.cType)
          formData.append("backMusic", this.backMusic)
          formData.append("scriptPrompt", this.scriptPrmpt.replace(/\n/gi , ' '))
          formData.append("addContentYn", this.addContentYn.type === this.addContentYnType[0].type ? true : false)
          formData.append("imagePrompt", this.imgPrmpt.replace(/\n/gi , ' '))
          formData.append("language", this.language.type)
          formData.append("imageGenerateYn", this.imgGenerateYn === this.imgGenerateYnType[0].type ? false : true)

          await this.api.axiosGql(type, formData)    
          .then( async (res) => {
            if(res === undefined || res.status !== 200) {
              this.emitter.emit('confirm', {message: `${this.t('sentence.retry')}`, header:'Auto', icon:'pi pi-exclamation-triangle'})
            } else this.emitter.emit('confirm', {message: `${this.t('sentence.cmplReg')}`, header:'Auto', icon:'pi pi-info-circle'})
          })
          
        }
        // else if(!this.) alert(' 누락')
      
        // console.log(type, this., this., this.quantity, this.playList, this.tag, this.keyword, this.imgPrmpt, this.scriptPrmpt, this.desc, this.title, this.youtubeName)
      } else if(type === 'typeChange') {
          this.disabledTitle = false
          this.disabledUrl = false
        if(this.content.type === this.contentType[0].type) {
          this.title = undefined
          this.url = undefined
          this.cType = 2 
        } else if(this.content.type === this.contentType[1].type) {
          this.disabledTitle = true
          this.url = undefined
          this.keyword = undefined
          this.cType = 1
        } else if(this.content.type === this.contentType[2].type) {
          this.disabledUrl = true
          this.title = undefined
          this.keyword = undefined
          this.cType = 0
        } else if(this.content.type === this.contentType[3].type) {
          this.disabledTitle = true
          this.disabledUrl = true
          this.keyword = undefined
          this.cType = 3
        }
      }
    },
  }
}
</script>

<style scoped>
  label { display: block; font-weight: bold; margin-bottom: 5px; }
  input[type="text"], input[type="url"], input[type="number"], select, textarea {
      width: 100%; padding: 8px; box-sizing: border-box;
  }
  textarea { height: 100px; resize: vertical; }
  .btn { padding: 8px 15px; cursor: pointer; background-color: #007bff; color: white; border: none; border-radius: 4px; }
  .btn-danger { background-color: #dc3545; }
  .btn-edit { background-color: #28a745; }
  .grid-form { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
  .full-width { grid-column: span 2; }

  .v3dp__input_wrapper > input {
    padding-top:5px;
    padding-bottom:5px; 
    max-width:70px;
    text-align: center;
  }
  .small-btn {
    width:30%;
    font-size:11px;
    margin-left: 2px;
    margin-right: 2px;
  }
  .width100 {
    width:100%;
  }
  .minWidth60 {
    min-width:60px;
  }
</style>


